// //old code
// import React, { useState } from 'react';
// import './ReviewBillPdf.css';
// import { Button } from '@mui/material';
// import WhatsAppIcon from '@mui/icons-material/WhatsApp';
// import numWords from 'num-words';
// import { MessageData } from './MessageData';
// import { Link } from 'react-router-dom';

// const ReviewBillPdf = ({ data, printRef, helpers }) => {
//   const [showModal, setShowModal] = useState(false);
//   const [rating, setRating] = useState(0);
//   const [feedback, setFeedback] = useState('');
//   const [imagePreview, setImagePreview] = useState(null);
//   const { capitalizeWords } = helpers || {};
//   const isWalletBill = data?.billType === 'Wallet';

//   const openModal = () => setShowModal(true);
//   const closeModal = () => {
//     setShowModal(false);
//     setRating(0);
//     setFeedback('');
//     setImagePreview(null);
//   };

//   const handleRating = (stars) => {
//     setRating(stars);
//   };

//   const handleImageUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setImagePreview(reader.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handlePrint = () => {
//     window.print();
//   };

//   const handleWhatsAppShare = () => {
//     const url = MessageData(data, {}, data.branchDetails, data.feedbackUrl, data.billUrl);
//     window.open(url, '_blank');
//   };
//   console.log(data, 'dataaaaaa')
//   return (
//     <div className="Review-main-container">
//       <div className="Review-invoice-box" ref={printRef}>
//         <div className="Review-header">
//           <div className="Review-header-content">
//             <img src={data?.branchDetails?.logo?.url} alt="" className="Review-logo" />
//           </div>
//         </div>

//         <h2>{data?.branchDetails?.branchName}</h2>
//         <p className="Review-address">{data?.branchDetails?.address}</p>

//         <h3 className="Review-tax">{isWalletBill ? 'WALLET TRANSACTION' : 'INVOICE'}</h3>
//         <div className="Review-gstin-box">
//           <div className="Review-dashed-line"></div>
//           <p>
//             <strong>GSTIN:</strong> {data?.branchDetails?.gstNumber || 'Unregistered'}
//           </p>
//           <div className="Review-dashed-line"></div>
//         </div>

//         <div className="Review-details-two-column">
//           <div className="Review-col">
//             <p>
//               <strong>Customer Name:</strong> {data?.clientName}
//             </p>
//             <p>
//               <strong>Invoice No.:</strong> {data?.invoice}
//             </p>
//           </div>
//           <div className="Review-col">
//             <p>
//               <strong>Contact:</strong> {data?.clientNumber}
//             </p>
//             <p>
//               <strong>Date & Time:</strong> {data?.formattedDate}
//               <br />
//               {data?.formattedTime}
//             </p>
//           </div>
//           {data?.ownerId === "68273f689a2875f3d47ec010" && (
//             <div className="Review-col">
//                 <p>
//                 <strong>Address:</strong> {data?.clientAddress}
//                 <br />
//               </p>
//               <p>
//                 <strong>Gst Number:</strong> {data?.clientGstNumber}
//               </p>
//               <p>
//                 <strong>Place of supply:</strong> {data?.clientPos}
//                 <br />
//               </p>
//             </div>
//           )}
//         </div>

//         {!isWalletBill ? (
//           <>
//             <table className="Review-items">
//               <thead>
//                 <tr>
//                   <th>Description</th>
//                   {data?.products?.length > 0 ? <th>HSN Code</th> : ''}
//                   <th>Rate</th>
//                   <th>Qty</th>
//                   <th>Discount</th>
//                   {data?.taxes?.taxType === 'Exclusive' ? <th>Gst</th> : ''}
//                   <th>Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {data?.billType === 'Membership' &&
//                   data?.memberships?.map((item, index) => (
//                     <tr key={`membership-${index}`}>
//                       <td>{item.membershipName}</td>
//                       <td>₹{parseFloat(item?.price).toFixed(2)}</td>
//                       <td style={{ textAlign: 'center' }}>{item?.quantity}</td>
//                       <td
//                         style={{
//                           color: item.discount > 0 ? '#000' : 'inherit',
//                           textAlign: 'center',
//                         }}
//                       >
//                         {item?.discount
//                           ? `${Number(item.discount).toFixed(2)}${item.discountType}`
//                           : '0%'}
//                       </td>
//                       {data?.taxes?.taxType === 'Exclusive' && <td>{data.taxes.SGST}%</td>}
//                       <td style={{ textAlign: 'center' }}>
//                         ₹
//                         {item?.amount ||
//                           item.price -
//                           (item.discountType === '%'
//                             ? (item.price * item.discount) / 100
//                             : item.discount) *
//                           item.quantity}
//                       </td>
//                     </tr>
//                   ))}

//                 {data?.billType === 'Package' &&
//                   data?.packages?.map((item, index) => (
//                     <tr key={`package-${index}`}>
//                       <td>{item.packageName}</td>
//                       <td>₹{parseFloat(item?.price).toFixed(2)}</td>
//                       <td style={{ textAlign: 'center' }}>{item?.quantity}</td>
//                       <td
//                         style={{
//                           color: item.discount > 0 ? '#000' : 'inherit',
//                           textAlign: 'center',
//                         }}
//                       >
//                         {item?.discount
//                           ? `${Number(item.discount).toFixed(2)}${item.discountType}`
//                           : '0%'}
//                       </td>
//                       {data?.taxes?.taxType === 'Exclusive' && <td>{data.taxes.SGST}%</td>}
//                       <td style={{ textAlign: 'center' }}>
//                         ₹
//                         {item?.amount ||
//                           item.price -
//                           (item.discountType === '%'
//                             ? (item.price * item.discount) / 100
//                             : item.discount) *
//                           item.quantity}
//                       </td>
//                     </tr>
//                   ))}

//                 {data?.billType !== 'Membership' &&
//                   data?.billType !== 'Package' &&
//                   data?.services?.map((item, index) => (
//                     <tr key={`service-${index}`}>
//                       <td>{item.serviceName}</td>
//                       {
//                         item?.hsnCode
//                           ? `${item?.hsnCode}` : data?.products?.length > 0 ? <td style={{ textAlign: 'center' }}>-</td> : ""
//                       }

//                       <td>₹{parseFloat(item?.price || 0).toFixed(2)}</td>
//                       <td style={{ textAlign: 'center' }}>{item?.quantity}</td>
//                       <td
//                         style={{
//                           color: item.discount > 0 ? '#000' : 'inherit',
//                           textAlign: 'center',
//                         }}
//                       >
//                         {item?.discount
//                           ? `${Number(item.discount).toFixed(2)}${item.discountType}`
//                           : '0%'}
//                       </td>
//                       {data?.taxes?.taxType === 'Exclusive' && <td>{data.taxes.SGST}%</td>}
//                       <td style={{ textAlign: 'center' }}>
//                         ₹{parseFloat(item.amount || 0).toFixed(2)}
//                       </td>
//                     </tr>
//                   ))}

//                 {data?.billType !== 'Membership' &&
//                   data?.billType !== 'Package' &&
//                   data?.products?.map((item, index) => (
//                     <tr key={`product-${index}`}>
//                       <td>
//                         {item.productName}
//                         <br />
//                         <small>Qty: {item.quantity}</small>
//                       </td>
//                       <td>
//                         {
//                           item?.product?.hsnCode
//                             ? `${item?.product?.hsnCode}` : "-"
//                         }
//                       </td>
//                       <td>₹{parseFloat(item?.price || 0).toFixed(2)}</td>
//                       <td style={{ textAlign: 'center' }}>{item?.quantity}</td>
//                       <td
//                         style={{
//                           color: item.discount > 0 ? '#000' : 'inherit',
//                           textAlign: 'center',
//                         }}
//                       >
//                         {item?.discount
//                           ? `${parseFloat(item.discount).toFixed(2)}${item.discountType}`
//                           : '0%'}
//                       </td>
//                       {data?.taxes?.taxType === 'Exclusive' && <td>18%</td>}
//                       <td style={{ textAlign: 'center' }}>
//                         ₹{parseFloat(item.amount || 0).toFixed(2)}
//                       </td>
//                     </tr>
//                   ))}
//               </tbody>
//             </table>
//           </>
//         ) : (
//           <>
//             {/* <table className="Review-items">
//                 <thead>
//                   <tr>
//                     <th>Wallet Recharge</th>
//                     <th>Amount</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr>
//                     <td>Value of Amount</td>
//                     <td style={{ textAlign: 'center' }}>₹{data?.amountAdded}</td>
//                   </tr>
//                   {data?.preAdvanceUsed > 0 && (
//                     <tr>
//                       <td>Previous Wallet Balance Used</td>
//                       <td style={{ textAlign: 'center' }}>-₹{data?.preAdvanceUsed}</td>
//                     </tr>
//                   )}
//                   {data?.amountPaid?.map((payment, index) => (
//                     <tr key={`payment-${index}`}>
//                       <td>Payment via {payment?.paymentType}</td>
//                       <td style={{ textAlign: 'center' }}>₹{payment?.amount}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table> */}
//           </>
//         )}

//         <div className="Review-total-summary">
//           {!isWalletBill ? (
//             <>
//               <div className="Review-total-row">
//                 <span>Subtotal:</span>
//                 <span>
//                   ₹
//                   {data?.billType === 'Membership'
//                     ? parseFloat(data?.memberships?.[0]?.price || 0).toFixed(2)
//                     : data?.billType === 'Package'
//                       ? parseFloat(data?.packages?.[0]?.price || 0).toFixed(2)
//                       : parseFloat(data?.baseTotal || 0).toFixed(2)}
//                 </span>
//               </div>

//               {(() => {
//                 const additionalDiscount = [...(data?.services || []), ...(data?.products || [])]
//                   .filter((item) => item.discount > 0 && item.discount !== 100)
//                   .reduce((sum, item) => {
//                     if (item.discountType === '%') {
//                       return sum + Math.round((item.price * item.quantity * item.discount) / 100);
//                     } else {
//                       return sum + item.discount;
//                     }
//                   }, 0);

//                 const shouldShowAdditionalDiscount =
//                   additionalDiscount > 0 &&
//                   (!data?.coupon?.discountAmount || data.coupon.discountAmount === 0);

//                 return (
//                   shouldShowAdditionalDiscount && (
//                     <div className="Review-total-row Review-discount">
//                       <span>Additional Discount:</span>
//                       <span>-₹{Math.round(additionalDiscount)}</span>
//                     </div>
//                   )
//                 );
//               })()}

//               {data?.useMembership && data?.services?.some((s) => s.discount === 100) && (
//                 <div className="Review-total-row Review-discount">
//                   <span>Membership Discount:</span>
//                   <span>
//                     -₹
//                     {data.services
//                       .filter((s) => s.discount === 100)
//                       .reduce((sum, s) => sum + s.price * s.quantity, 0)}
//                   </span>
//                 </div>
//               )}

//               {data?.coupon?.discountAmount > 0 && (
//                 <div className="Review-total-row Review-discount">
//                   <span>Coupon Discount:</span>
//                   <span>-₹{data?.coupon?.discountAmount}</span>
//                 </div>
//               )}

//               {data?.packageUniqueId?.length > 0 &&
//                 data.services?.some((s) => s.discount === 100) && (
//                   <div className="Review-total-row Review-discount">
//                     <span>Package Discount:</span>
//                     <span>
//                       -₹
//                       {data.services
//                         .filter((s) => s.discount === 100)
//                         .reduce((sum, s) => sum + s.price * s.quantity, 0)}
//                     </span>
//                   </div>
//                 )}

//               {data?.rewardPointRedeemAmount > 0 && (
//                 <div className="Review-total-row Review-discount">
//                   <span>Reward Points:</span>
//                   <span>-₹{data?.rewardPointRedeemAmount}</span>
//                 </div>
//               )}

//               <div className="Review-total-row Review-net-amount">
//                 <span>Net Amount (After Discounts):</span>
//                 <span>
//                   ₹
//                   {data.rewardPointRedeemAmount > 0
//                     ? parseFloat(data?.subTotal || 0) - data.rewardPointRedeemAmount
//                     : parseFloat(data?.subTotal || 0)}
//                 </span>
//               </div>

//               {data?.taxes?.taxType === 'Exclusive' && (
//                 <>
//                   <div className="Review-total-row">
//                     <span>SGST :</span>
//                     <span>+₹{Math.round((data?.totalAmount - data?.subTotal) / 2)}</span>
//                   </div>
//                   <div className="Review-total-row">
//                     <span>CGST :</span>
//                     <span>+₹{Math.round((data?.totalAmount - data?.subTotal) / 2)}</span>
//                   </div>
//                 </>
//               )}
//             </>
//           ) : (
//             <>
//               <div className="Review-total-row">
//                 <span>Amount Credited in Wallet :</span>
//                 <span>₹{data?.amountAdded}</span>
//               </div>
//               {data?.preAdvanceUsed > 0 && (
//                 <div className="Review-total-row Review-discount">
//                   <span>Previous Wallet Balance Used:</span>
//                   <span>-₹{data?.preAdvanceUsed}</span>
//                 </div>
//               )}
//               {data?.prePaidDues > 0 && (
//                 <div className="Review-total-row">
//                   <span>Previous Dues Paid:</span>
//                   <span>₹{data?.prePaidDues}</span>
//                 </div>
//               )}
//               <div className="Review-total-row">
//                 <span>Subtotal:</span>
//                 <span>₹{data?.subTotal}</span>
//               </div>
//               {data?.taxes?.taxType === 'Exclusive' && (
//                 <>
//                   <div className="Review-total-row">
//                     <span>SGST :</span>
//                     <span>+₹{Math.round((data?.totalAmount - data?.subTotal) / 2)}</span>
//                   </div>
//                   <div className="Review-total-row">
//                     <span>CGST :</span>
//                     <span>+₹{Math.round((data?.totalAmount - data?.subTotal) / 2)}</span>
//                   </div>
//                 </>
//               )}
//             </>
//           )}

//           <div className="Review-total-row Review-total-payable">
//             <span>Total Amount:</span>
//             <span>₹{data?.amountPayable}</span>
//           </div>

//           <div className="Review-total-row Review-amount-received">
//             <span>Amount Received:</span>
//             <span>₹{data?.amountPaid?.reduce((a, b) => a + Number(b.amount), 0)}</span>
//           </div>

//           {data.paidDues > 0 && (
//             <div className="standard-summary-row standard-due-row">
//               <span>Due Balance:</span>
//               <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>₹{data.paidDues}</span>
//             </div>
//           )}

//           {data?.remainingWalletAmount && (
//             <div className="Review-total-row">
//               <span>Remaining Wallet Balance:</span>
//               <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>
//                 ₹{data?.remainingWalletAmount}
//               </span>
//             </div>
//           )}

//           <div className="Review-amount-words">
//             <p>
//               <strong>Amount in words:</strong>{' '}
//               {(() => {
//                 if (!data?.amountPayable || isNaN(data.amountPayable)) {
//                   return 'Zero Rupees Only';
//                 }

//                 const [rupees, paise] = data.amountPayable.toString().split('.');

//                 let words = capitalizeWords(numWords(parseInt(rupees))) + ' Rupees';
//                 if (paise && parseInt(paise) > 0) {
//                   words += ' and ' + capitalizeWords(numWords(parseInt(paise))) + ' Paise';
//                 }
//                 return words + ' Only';
//               })()}
//             </p>
//           </div>
//         </div>

//         <div className="Review-thankyou-section">
//           <p>*** THANK YOU ***</p>
//           <p>We Look Forward To Your Next Visit</p>
//         </div>

//         <div className="Review-bottom-buttons">
//           <img src={data?.branchDetails?.logo?.url} className="Review-small-logo" alt="logo" />
//           <button className="Review-sticky-buttons" onClick={openModal}>
//             Rate Your Visit
//           </button>
//           <button className="Review-sticky-buttons">Call Us</button>
//         </div>

//         <div className="thermal-footer">
//           <p>
//             This Bill is Powered by <Link to="https://yoursalon.in/">YourSalon.in</Link>
//           </p>
//         </div>
//       </div>

//       {/* Feedback Modal */}
//       {showModal && (
//         <div className="Review-modal">
//           <div className="Review-modal-content">
//             <h3>{data?.branchDetails?.branchName}</h3>
//             <img src={data?.branchDetails?.logo?.url} alt="logo" className="Review-modal-logo" />
//             <div className="Review-stars">
//               {[1, 2, 3, 4, 5].map((star) => (
//                 <span
//                   key={star}
//                   className={`Review-star ${rating >= star ? 'Review-selected' : ''}`}
//                   onClick={() => handleRating(star)}
//                 >
//                   ★
//                 </span>
//               ))}
//             </div>
//             <textarea
//               rows="4"
//               placeholder="Share your experience..."
//               value={feedback}
//               onChange={(e) => setFeedback(e.target.value)}
//             ></textarea>

//             <label htmlFor="photoInput" className="Review-photo-upload">
//               📷 Add a photo
//             </label>
//             <input
//               type="file"
//               id="photoInput"
//               style={{ display: 'none' }}
//               accept="image/*"
//               onChange={handleImageUpload}
//             />
//             {imagePreview && (
//               <div className="Review-image-preview">
//                 <img src={imagePreview} alt="Preview" />
//               </div>
//             )}
//             <div className="Review-actions">
//               <button className="Review-cancel-btn" onClick={closeModal}>
//                 Cancel
//               </button>
//               <button className="Review-post-btn">Post</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Action Buttons */}
//       <div className="Review-action-buttons">
//         <Button
//           variant="contained"
//           className="Review-whatsapp-button"
//           sx={{
//             backgroundColor: '#25D366',
//           }}
//           onClick={handleWhatsAppShare}
//           startIcon={<WhatsAppIcon />}
//         >
//           WhatsApp
//         </Button>
//         <Button variant="contained" className="Review-print-button" onClick={handlePrint}>
//           Print Bill
//         </Button>
//       </div>
//     </div>
//   );
// };

// export default ReviewBillPdf;

import React, { useState } from 'react';
import './ReviewBillPdf.css';
import { Button } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import numWords from 'num-words';
import { MessageData } from './MessageData';
import { Link } from 'react-router-dom';
import { changeDateFormate } from "../../../utils/dateutils"

const ReviewBillPdf = ({ data, printRef, helpers }) => {
  const [showModal, setShowModal] = useState(false);
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [imagePreview, setImagePreview] = useState(null);
  const { capitalizeWords } = helpers || {};

  // Bill type conditions
  const isMembershipBill = data?.billType === 'Membership';
  const isPackageBill = data?.billType === 'Package';
  const isWalletBill = data?.billType === 'Wallet';
  const isRegularBill = data?.billType === 'Bill';

  const openModal = () => setShowModal(true);
  const closeModal = () => {
    setShowModal(false);
    setRating(0);
    setFeedback('');
    setImagePreview(null);
  };

  const handleRating = (stars) => {
    setRating(stars);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const handleWhatsAppShare = () => {
    const url = MessageData(data, {}, data.branchDetails, data.feedbackUrl, data.billUrl);
    window.open(url, '_blank');
  };

  // Helper functions for different bill types
  // const renderServicesList = () => {
  //   if (isMembershipBill && data?.membershipDetails?.servicesOffered) {
  //     return (
  //       <div className="Review-services-list">
  //         <h4>Membership Services Included:</h4>
  //         <ul>
  //           {data.membershipDetails.servicesOffered.map((serviceItem, index) => (
  //             <li key={index}>
  //               {serviceItem.service?.serviceName} 
  //               {serviceItem.availableCount && ` (${serviceItem.availableCount} sessions)`}
  //             </li>
  //           ))}
  //         </ul>
  //       </div>
  //     );
  //   }

  //   if (isPackageBill && data?.servicesPackage?.services) {
  //     return (
  //       <div className="Review-services-list">
  //         <h4>Package Services Included:</h4>
  //         <ul>
  //           {data.servicesPackage.services.map((service, index) => (
  //             <li key={index}>
  //               {service.serviceName} (1 session)
  //             </li>
  //           ))}
  //         </ul>
  //       </div>
  //     );
  //   }

  //   return null;
  // };

  const hasRemainingServices = data?.remainingServices?.length > 0;
  const hasDueHistory = data?.dueBillHistory?.length > 0;
  const renderDueHistoryTable = () => {
    if (!hasDueHistory) return null;
    let remainingAmount = 0;
    let totalAmount = data.paidDues - remainingAmount;

    return (
      <div className="review-remaining-services-list">
        <h6 style={{ marginTop: '10px' }}>
          {data?.dueBillHistory.length > 0 ? 'Due Cleared History:' : ''}
        </h6>
        <div className="review-remaining-services-table ">
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th style={{ textAlign: 'center' }}>Total</th>
                <th style={{ textAlign: 'center' }}>Paid</th>
                <th style={{ textAlign: 'center' }}>Payment Mode</th>
                <th style={{ textAlign: 'center' }}>Due</th>
              </tr>
            </thead>
            <tbody>
              {data.dueBillHistory.map((history, index) => {
                remainingAmount = totalAmount - history.paidAmount;
                const row = (
                  <tr key={index}>
                    <td>{changeDateFormate(history.paymentDate)}</td>
                    <td style={{ textAlign: 'center' }}>{totalAmount}</td>
                    <td style={{ textAlign: 'center' }}>{history.paidAmount}</td>
                    <td style={{ textAlign: 'center' }}>{history.paymentType}</td>
                    <td style={{ textAlign: 'center' }}>{remainingAmount}</td>
                  </tr>
                );
                totalAmount = remainingAmount;
                return row;
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const renderRemainingServicesTable = () => {
    if (!hasRemainingServices) return null;

    return (
      <div className="review-remaining-services-list">
        <h6 style={{ marginTop: '10px' }}>{data?.packageUniqueId.length > 0 ? 'Remaining Package Services:' : "Remaining Membership Services:"}</h6>
        <div className="review-remaining-services-table ">
          <table>
            <thead>
              <tr>
                <th>Service Name</th>
                <th>Count</th>
              </tr>
            </thead>
            <tbody>
              {data.remainingServices.map((service, index) => (
                <tr key={index}>
                  <td>• {service.serviceName}</td>
                  <td style={{ textAlign: 'center' }}>
                    {service.count || 1}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const renderServicesList = () => {
    if (isMembershipBill && data?.membershipDetails) {
      const { membershipType, servicesOffered, discount } = data.membershipDetails;

      if (membershipType === 'serviceType' && servicesOffered?.length > 0) {
        return (
          <div className="standard-services-list">
            <h6 style={{ marginTop: '10px' }}>Membership Services</h6>
            <div className="membership-services-table">
              <table>
                <thead>
                  <tr>
                    <th>Service Name</th>
                    <th>Count</th>
                  </tr>
                </thead>
                <tbody>
                  {servicesOffered.map((serviceItem, index) => (
                    <tr key={index}>
                      <td>• {serviceItem.service?.serviceName}</td>
                      <td style={{ textAlign: 'center' }}>{serviceItem.availableCount || '0'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );
      }

      if (membershipType === 'discountType' && discount) {
        return (
          <div className="Review-services-list">
            <h6 style={{ marginTop: '10px' }}>Membership Benefits:</h6>
            <div className="Review-discount-benefits">
              <table>
                <tbody>
                  {discount.discountOnService > 0 && (
                    <tr>
                      <td><strong>Discount on services:</strong></td>
                      <td>{discount.discountOnService}{discount.serviceDiscountType === '%' ? '%' : '₹'} off on all services</td>
                    </tr>
                  )}
                  {discount.discountOnProduct > 0 && (
                    <tr>
                      <td><strong>Discount on Product:</strong></td>
                      <td>{discount.discountOnProduct}{discount.productDiscountType === '%' ? '%' : '₹'} off on all products</td>
                    </tr>
                  )}
                  {discount.minBillAmount > 0 && (
                    <tr>
                      <td><strong>Minimum Bill Amount:</strong></td>
                      <td>₹{discount.minBillAmount}</td>
                    </tr>
                  )}
                  {discount.availableCount > 0 && (
                    <tr>
                      <td><strong>Available Count:</strong></td>
                      <td>{discount.availableCount} Count</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        );
      }
    }

    //   if (isPackageBill && data?.servicesPackage?.services) {
    //     return (
    //       <div className="Review-services-list">
    //         <h4>Package Services Included:</h4>
    //         <ul>
    //           {data.servicesPackage.services.map((service, index) => (
    //             <li key={index}>
    //               {service.serviceName} (1 Count)
    //             </li>
    //           ))}
    //         </ul>
    //       </div>
    //     );
    //   }

    //   return null;
    // };
    if (isPackageBill && data?.servicesPackage?.services) {
      return (
        <div className="Review-services-list">
          <h6 style={{ marginTop: '10px' }}>Package Services</h6>
          <div className="membership-services-table">
            <table>
              <thead>
                <tr>
                  <th>Service Name</th>
                  <th>Count</th>
                </tr>
              </thead>
              <tbody>
                {data.servicesPackage.services.map((service, index) => (
                  <tr key={index}>
                    <td>• {service.serviceName}</td>
                    <td style={{ textAlign: 'center' }}>1</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      );
    }
    return null
  }

  const renderMainTable = () => {
    if (isWalletBill) {
      return renderWalletTable();
    }
    const showGstColumn = !!data?.branchDetails?.gstNumber;

    return (
      <table className="Review-items">
        <thead>
          <tr>
            <th>Description</th>
            {data?.products?.length > 0 ? <th>HSN Code</th> : ''}
            <th>Taxable Value</th>
            <th>Qty</th>
            <th>Discount</th>
             {showGstColumn && <th style={{ textAlign: 'center' }}>Gst</th>}
            <th style={{ textAlign: 'center' }}>Amount</th>
          </tr>
        </thead>
        <tbody>
          {renderTableRows(showGstColumn)}
        </tbody>
      </table>
    );
  };

  const renderTableRows = (showGstColumn) => {
    if (isMembershipBill) {
      return data?.memberships?.map((item, index) => (
        <ReviewTableRow
          key={`membership-${index}`}
          description={item?.membershipName}
          price={item?.price}
          quantity={item?.quantity}
          discount={item?.discount}
          discountType={item?.discountType}
          amount={item?.amount || calculateAmount(item)}
          showGst={showGstColumn}
          gstRate={data?.taxes?.SGST}
          taxStatus={item?.taxStatus}
                    gstValue={item?.gstValue}
          gstPercent={item?.gstPercent}
                    showHsn={data?.products?.length > 0}
        />
      ));
    }

    if (isPackageBill) {
      return data?.packages?.map((item, index) => (
        <ReviewTableRow
          key={`package-${index}`}
          description={item?.packageName}
          price={item?.price}
          quantity={item?.quantity}
          discount={item?.discount}
          discountType={item?.discountType}
          amount={item?.amount || calculateAmount(item)}
          showGst={showGstColumn}
          gstRate={data?.taxes?.SGST}
          taxStatus={item?.taxStatus}
          gstPercent={item?.gstPercent}
                    gstValue={item?.gstValue}
                    showHsn={data?.products?.length > 0}

        />
      ));
    }

    // Regular bill with services and products
    return (
      <>
        {data?.services?.map((item, index) => (
          <ReviewServiceRow
            key={`service-${index}`}
            item={item}
            showGst={showGstColumn}
            gstRate={data?.taxes?.SGST}
            showHsn={data?.products?.length > 0}
          />
        ))}
        {data?.products?.map((item, index) => (
          <ReviewProductRow
            key={`product-${index}`}
            item={item}
            showGst={showGstColumn}
          />
        ))}
      </>
    );
  };

  const renderWalletTable = () => {
    return (
      <table className="Review-items">
        <thead>
          <tr>
            <th>Wallet Recharge</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Amount Credited in Wallet</td>
            <td style={{ textAlign: 'center' }}>₹{data?.amountAdded}</td>
          </tr>
          {data?.preAdvanceUsed > 0 && (
            <tr>
              <td>Previous Wallet Balance Used</td>
              <td style={{ textAlign: 'center' }}>-₹{data?.preAdvanceUsed}</td>
            </tr>
          )}
          <tr>
            <td>Amount Received</td>
            <td style={{ textAlign: 'center' }}>
              ₹{data?.amountPaid?.reduce((acc, payment) => acc + payment?.amount, 0)}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  const calculateAmount = (item) => {
    // const discountAmount = item.discountType === '%'
    //   ? (item.price * item.discount) / 100
    //   : item.discount;
    // return item.price - discountAmount;
     const price = Number(item.price) || 0;
    const quantity = Number(item.quantity) || 1;
    if (item.discountType === '%') {
      const discountAmount = (price * item.discount) / 100;
      return (price - discountAmount) * quantity;
    } else {
      // INR discount: flat amount deducted from total
      return Math.max(0, (price * quantity) - (Number(item.discount) || 0));
    }
  };

  const getAmountInWords = () => {
    if (!data?.amountPayable || isNaN(data.amountPayable)) {
      return 'Zero Rupees Only';
    }

    const [rupees, paise] = data.amountPayable.toString().split('.');
    let words = capitalizeWords(numWords(parseInt(rupees))) + ' Rupees';

    if (paise && parseInt(paise) > 0) {
      words += ' and ' + capitalizeWords(numWords(parseInt(paise))) + ' Paise';
    }
    return words + ' Only';
  };

  return (
    <div className="Review-main-container">
      <div className="Review-invoice-box" ref={printRef}>
        <div className="Review-header">
          <div className="Review-header-content">
            <img src={data?.branchDetails?.logo?.url} alt="" className="Review-logo" />
          </div>
        </div>

        <h2>{data?.branchDetails?.branchName}</h2>
        <p className="Review-address">{data?.branchDetails?.address}</p>

        <h3 className="Review-tax">{isWalletBill ? 'WALLET TRANSACTION' : 'INVOICE'}</h3>
        <div className="Review-gstin-box">
          <div className="Review-dashed-line"></div>
          <p>
            <strong>GSTIN:</strong> {data?.branchDetails?.gstNumber || 'Unregistered'}
          </p>
          <div className="Review-dashed-line"></div>
        </div>

        <div className="Review-details-two-column">
          <div className="Review-col">
            <p>
              <strong>Customer Name:</strong> {data?.clientName}
            </p>
            <p>
              <strong>Invoice No.:</strong> {data?.invoice}
            </p>

          </div>
          <div className="Review-col">
            <p>
              <strong>Contact:</strong> {data?.clientNumber}
            </p>
            <p>
              <strong>Date & Time:</strong> {data?.formattedDate}
              <br />
              {data?.formattedTime}
            </p>
            {data?.billType === "Package" && (
              <p className=""><strong>Bill Type:</strong> Package Bill</p>
            )}
            {data?.billType === "Membership" && (
              <p className=""><strong>Bill Type: </strong> Membership Bill</p>
            )}

          </div>
                 {data?.branchDetails?.gstNumber && (
          <div className="Review-client-details" style={{ margin: '10px 0', padding: '0 10px' }}>
            <p>
              <strong>Address:</strong> {data?.clientAddress}
              <br />
            </p>
            <p>
              <strong>Gst Number:</strong> {data?.clientGstNumber}
            </p>
            <p>
              <strong>Place of supply:</strong> {data?.clientPos}
              <br />
            </p>
          </div>
          )}
        </div>

        {/* Main Table Section */}
        {renderMainTable()}

        {/* Services List for Membership and Package */}
        {(isMembershipBill || isPackageBill) && renderServicesList()}
        {/* Remaining Services Table */}
        {hasRemainingServices && renderRemainingServicesTable()}

        {
          data?.billType === "Package" && (
            <p className=""><strong>Valid Till:</strong>  {changeDateFormate(data?.endDate)}</p>
          )
        }
        {
          data?.billType === "Membership" && (
            <p className=""><strong>Valid Till:</strong> {changeDateFormate(data?.endDate)}</p>
          )
        }

        {/* Summary Section */}
        <ReviewSummarySection data={data} isWalletBill={isWalletBill} />
        {hasDueHistory && renderDueHistoryTable()}

        <div className="Review-amount-words">
          <p>
            <strong>Amount in words:</strong> {getAmountInWords()}
          </p>
        </div>
         <div className="Review-amount-words">
          <p>
            <strong>Note:</strong> {data.noteForClient}
          </p>
        </div>

        <div className="Review-thankyou-section">
          <p>*** THANK YOU ***</p>
          <p>We Look Forward To Your Next Visit</p>
        </div>

        <div className="Review-bottom-buttons">
          <img src={data?.branchDetails?.logo?.url} className="Review-small-logo" alt="logo" />
          <button className="Review-sticky-buttons" onClick={openModal}>
            Rate Your Visit
          </button>
          <button className="Review-sticky-buttons">Call Us</button>
        </div>

        <div className="thermal-footer">
          <p>
            This Bill is Powered by <Link to="https://yoursalon.in/">YourSalon.in</Link>
          </p>
        </div>
      </div>

      {/* Feedback Modal */}
      {showModal && (
        <div className="Review-modal">
          <div className="Review-modal-content">
            <h3>{data?.branchDetails?.branchName}</h3>
            <img src={data?.branchDetails?.logo?.url} alt="logo" className="Review-modal-logo" />
            <div className="Review-stars">
              {[1, 2, 3, 4, 5].map((star) => (
                <span
                  key={star}
                  className={`Review-star ${rating >= star ? 'Review-selected' : ''}`}
                  onClick={() => handleRating(star)}
                >
                  ★
                </span>
              ))}
            </div>
            <textarea
              rows="4"
              placeholder="Share your experience..."
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
            ></textarea>

            <label htmlFor="photoInput" className="Review-photo-upload">
              📷 Add a photo
            </label>
            <input
              type="file"
              id="photoInput"
              style={{ display: 'none' }}
              accept="image/*"
              onChange={handleImageUpload}
            />
            {imagePreview && (
              <div className="Review-image-preview">
                <img src={imagePreview} alt="Preview" />
              </div>
            )}
            <div className="Review-actions">
              <button className="Review-cancel-btn" onClick={closeModal}>
                Cancel
              </button>
              <button className="Review-post-btn">Post</button>
            </div>
          </div>
        </div>
      )}

      {/* Action Buttons */}
      <div className="Review-action-buttons">
        <Button
          variant="contained"
          className="Review-whatsapp-button"
          sx={{ backgroundColor: '#25D366' }}
          onClick={handleWhatsAppShare}
          startIcon={<WhatsAppIcon />}
        >
          WhatsApp
        </Button>
        <Button variant="contained" className="Review-print-button" onClick={handlePrint}>
          Print Bill
        </Button>
      </div>
    </div>
  );
};

// Reusable Table Row Components for ReviewBillPdf
const ReviewTableRow = ({
  description,
  price,
  quantity,
  discount,
  discountType,
  amount,
  showGst,
  gstRate,
  taxStatus,
  gstPercent,
  gstValue,
  showHsn
}) => {
  // const effectiveGstRate = Number(gstPercent > 0 ? gstPercent : (gstRate || 0));
  // const displayedPrice = (taxStatus === 'withTax' && effectiveGstRate > 0)
  //   ? (Number(price || 0) / (1 + effectiveGstRate / 100)).toFixed(2)
  const displayedPrice = (taxStatus === 'withTax' && gstPercent > 0)
    ? (Number(price || 0) / (1 + (gstPercent || 0) / 100)).toFixed(2)
    : parseFloat(price || 0).toFixed(2);

  return (
    <tr>
            <td style={{ padding: '8px 4px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{description}</td>
      {showHsn && <td style={{ textAlign: 'center', padding: '8px 4px' }}>-</td>}
      <td style={{ textAlign: 'center', padding: '8px 4px' }}>₹{displayedPrice}</td>
      <td style={{ textAlign: 'center', padding: '8px 4px' }}>{quantity}</td>
      <td style={{ color: discount > 0 ? '#000' : 'inherit', textAlign: 'center', padding: '8px 4px' }}>
        {discount ? `${Number(discount).toFixed(0)}${discountType}` : '0%'}
      </td>
      {showGst && (
        <td style={{ textAlign: 'center', padding: '8px 4px', fontSize: '11px' }}>
          {!(Number(discount) === 100 && discountType === '%')
                       ? `${gstPercent || 0}% (₹${(gstValue || 0).toFixed(2)})`
            : '-'}
        </td>
      )}
      <td style={{ textAlign: 'center', padding: '8px 4px' }}>₹{amount}</td>
    </tr>
  );
};

const ReviewServiceRow = ({ item, showGst, gstRate, showHsn }) => {
 const displayedPrice = (item?.taxStatus === 'withTax' && item?.gstPercent > 0)
    ? (Number(item?.price || 0) / (1 + item.gstPercent / 100)).toFixed(2)
    : parseFloat(item?.price || 0).toFixed(2);

  return (
    <tr>
     <td style={{ padding: '8px 4px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.serviceName}</td>
      {showHsn && <td style={{ textAlign: 'center', padding: '8px 4px' }}>{item?.hsnCode || '-'}</td>}
      <td style={{ textAlign: 'center', padding: '8px 4px' }}>₹{displayedPrice}</td>
      <td style={{ textAlign: 'center', padding: '8px 4px' }}>{item?.quantity}</td>
      <td style={{ color: item.discount > 0 ? '#000' : 'inherit', textAlign: 'center', padding: '8px 4px' }}>
        {item?.discount
          ? `${Number(item.discount).toFixed(0)}${item.discountType}`
          : '0%'}
      </td>
      {showGst && (
        <td style={{ textAlign: 'center', padding: '8px 4px', fontSize: '11px' }}>
          {!(Number(item?.discount) === 100 && item?.discountType === '%') && item?.taxStatus !== 'noGst'
                        ? `${item?.gstPercent || 0}% (₹${(item?.gstValue || 0).toFixed(2)})`
            : '-'}
        </td>
      )}
      <td style={{ textAlign: 'center' }}>₹{parseFloat(item.amount || 0).toFixed(2)}</td>
    </tr>
  );
};

const ReviewProductRow = ({ item, showGst }) => {
  const displayedProdPrice = (item?.taxStatus === 'withTax' && item?.gstPercent > 0)
    ? (Number(item?.price || 0) / (1 + item.gstPercent / 100)).toFixed(2)
    : parseFloat(item?.price || 0).toFixed(2);

  return (
    <tr>
      <td style={{ padding: '8px 4px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {item.productName}
      </td>
      <td style={{ textAlign: 'center', padding: '8px 4px' }}>{item?.product?.hsnCode ? `${item?.product?.hsnCode}` : "-"}</td>
      <td style={{ textAlign: 'center', padding: '8px 4px' }}>₹{displayedProdPrice}</td>
      <td style={{ textAlign: 'center', padding: '8px 4px' }}>{item?.quantity}</td>
      <td style={{ color: item.discount > 0 ? '#000' : 'inherit', textAlign: 'center', padding: '8px 4px' }}>
        {item?.discount
          ? `${parseFloat(item.discount).toFixed(0)}${item.discountType}`
          : '0%'}
      </td>
      {showGst && (
        <td style={{ textAlign: 'center', padding: '8px 4px', fontSize: '11px' }}>
          {!(Number(item?.discount) === 100 && item?.discountType === '%')
                       ? `${item?.gstPercent || 0}% (₹${(item?.gstValue || 0).toFixed(2)})`
            : '-'}
        </td>
      )}
      <td style={{ textAlign: 'center', padding: '8px 4px' }}>₹{parseFloat(item.amount || 0).toFixed(2)}</td>
    </tr>
  );
};

// Separate Summary Section Component
const ReviewSummarySection = ({ data, isWalletBill }) => {
  const totalGstFromItems = [
    ...(data?.services || []),
    ...(data?.products || []),
    ...(data?.memberships || []),
    ...(data?.packages || []),
  ].reduce((sum, item) => sum + (Number(item?.gstValue) || 0), 0);

  const totalGstValue = totalGstFromItems > 0 ? totalGstFromItems : Math.max(0, Number(data?.totalAmount || 0) - Number(data?.subTotal || 0));
  // Calculate taxable subtotal = sum of (amount with GST extracted if withTax)
  const calculateTaxableSubTotal = () => {
    const allItems = [
      ...(data?.services || []),
      ...(data?.products || []),
      ...(data?.memberships || []),
      ...(data?.packages || []),
    ];

    return allItems.reduce((sum, item) => {
      const price = Number(item?.price || 0);
      const quantity = Number(item?.quantity ?? 1);
      const taxStatus = item?.taxStatus || 'noGst';
      const isProduct = !item?.serviceName && !item?.membershipName && !item?.packageName;
      const gstRate = Number(item?.gstPercent > 0 ? item.gstPercent : (isProduct
        ? (item?.product?.GST ?? item?.gst ?? 18)
        : (data?.taxes?.SGST || 0)));

      let taxableValue = price;
      if (taxStatus === 'withTax' && gstRate > 0) {
        taxableValue = Number((price / (1 + gstRate / 100)).toFixed(2));
      }

      return sum + (taxableValue * quantity);
    }, 0);
  };

  const taxableSubTotal = calculateTaxableSubTotal();

  const calculateAdditionalDiscount = () => {
    const totalDiscount = [...(data?.services || []), ...(data?.products || [])]
      .filter((item) => {
        const isFullPercentDiscount = Number(item.discount) === 100 && item.discountType === '%';
        return Number(item.discount) > 0 && !isFullPercentDiscount;
      })
      .reduce((sum, item) => {
        const price = Number(item?.price || 0);
        const quantity = Number(item?.quantity || 1);
        const amount = Number(item?.amount || 0);
        const taxStatus = item?.taxStatus || 'noGst';
        const isProduct = !item?.serviceName && !item?.membershipName && !item?.packageName;
        const gstRate = Number(item?.gstPercent > 0 ? item.gstPercent : (isProduct
          ? (item?.product?.GST ?? item?.gst ?? 18)
          : (data?.taxes?.SGST || 0)));

        let lineTotal = price * quantity;
        let finalAmount = amount;

        if (taxStatus === 'withTax' && gstRate > 0) {
          const taxablePrice = Number((price / (1 + gstRate / 100)).toFixed(2));
          lineTotal = taxablePrice * quantity;
          finalAmount = Number((amount / (1 + gstRate / 100)).toFixed(2));
        }

        const discountVal = lineTotal - finalAmount;
        return sum + discountVal;
      }, 0);

    return totalDiscount;
  };

  const additionalDiscount = calculateAdditionalDiscount();
  const shouldShowAdditionalDiscount = additionalDiscount > 0 &&
    (!data?.coupon?.discountAmount || data.coupon.discountAmount === 0);

  return (
    <div className="Review-total-summary">
      {!isWalletBill ? (
        <>
          <div className="Review-total-row">
            <span>Subtotal (Taxable) :</span>
            <span>₹{taxableSubTotal.toFixed(2)}</span>
          </div>

          {shouldShowAdditionalDiscount && (
            <div className="Review-total-row Review-discount">
              <span>Additional Discount:</span>
              <span>-₹{Math.round(additionalDiscount)}</span>
            </div>
          )}

          {data?.useMembership && data?.services?.some((s) => Number(s.discount) === 100 && s.discountType === '%') && (
            <div className="Review-total-row Review-discount">
              <span>Membership Discount:</span>
              <span>
                -₹
                {data.services
                  .filter((s) => Number(s.discount) === 100 && s.discountType === '%')
                  .reduce((sum, s) => sum + s.price * s.quantity, 0)}
              </span>
            </div>
          )}

          {data?.coupon?.discountAmount > 0 && (
            <div className="Review-total-row Review-discount">
              <span>Coupon Discount:</span>
              <span>-₹{data?.coupon?.discountAmount}</span>
            </div>
          )}

          {data?.packageUniqueId?.length > 0 && data.services?.some((s) => Number(s.discount) === 100 && s.discountType === '%') && (
            <div className="Review-total-row Review-discount">
              <span>Package Discount:</span>
              <span>
                -₹
                {data.services
                  .filter((s) => Number(s.discount) === 100 && s.discountType === '%')
                  .reduce((sum, s) => sum + s.price * s.quantity, 0)}
              </span>
            </div>
          )}

          {data?.rewardPointRedeemAmount > 0 && (
            <div className="Review-total-row Review-discount">
              <span>Reward Points:</span>
              <span>-₹{data?.rewardPointRedeemAmount}</span>
            </div>
          )}

          <div className="Review-total-row Review-net-amount">
                <span>Net Amount :</span>
            <span>
              ₹
              {data.rewardPointRedeemAmount > 0
                ? parseFloat(data?.subTotal || 0) - data.rewardPointRedeemAmount
                : parseFloat(data?.subTotal || 0)}
            </span>
          </div>

          {(data?.taxes?.taxType === 'Exclusive' || data?.taxes?.taxType === 'Ingst') &&
            (totalGstValue / 2) > 0 && (
              <>
                <div className="Review-total-row">
                  <span>SGST :</span>
                  <span>+₹{(totalGstValue / 2).toFixed(2)}</span>
                </div>
                <div className="Review-total-row">
                  <span>CGST :</span>
                  <span>+₹{(totalGstValue / 2).toFixed(2)}</span>
                </div>
              </>
            )}
        </>
      ) : (
        // Wallet Bill Summary
        <>
          <div className="Review-total-row">
            <span>Amount Credited in Wallet :</span>
            <span>₹{data?.amountAdded}</span>
          </div>
          {data?.preAdvanceUsed > 0 && (
            <div className="Review-total-row Review-discount">
              <span>Previous Wallet Balance Used:</span>
              <span>-₹{data?.preAdvanceUsed}</span>
            </div>
          )}
          {data?.prePaidDues > 0 && (
            <div className="Review-total-row">
              <span>Previous Dues Paid:</span>
              <span>₹{data?.prePaidDues}</span>
            </div>
          )}
          <div className="Review-total-row">
            <span>Subtotal:</span>
            <span>₹{data?.subTotal}</span>
          </div>
          {(data?.taxes?.taxType === 'Exclusive' || data?.taxes?.taxType === 'Ingst') && (
              <>
                <div className="Review-total-row">
                <span>SGST :</span>
                  <span>+₹{(totalGstValue / 2).toFixed(2)}</span>
              </div>
              <div className="Review-total-row">
                <span>CGST :</span>
                  <span>+₹{(totalGstValue / 2).toFixed(2)}</span>
              </div>
            </>
          )}
        </>
      )}

      <div className="Review-total-row Review-total-payable">
        <span>Total Amount:</span>
        <span>₹{data?.amountPayable}</span>
      </div>

      <div className="Review-total-row Review-amount-received">
        <span>Amount Received:</span>
        <span>₹{data?.amountPaid?.reduce((a, b) => a + Number(b.amount), 0)}</span>
      </div>

      {data.paidDues > 0 && (
        <div className="Review-total-row Review-due-amount">
          <span>Due Balance:</span>
          <span>₹{data.paidDues}</span>
        </div>
      )}

      {/* {data?.remainingWalletAmount && (
        <div className="Review-total-row">
          <span>Remaining Wallet Balance:</span>
          <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>
            ₹{data?.remainingWalletAmount}
          </span>
        </div>
      )} */}
      {(data?.remainingWalletAmount || 
            data?.amountPaid?.some((p) => p.paymentType === 'Wallet')) && (
            <div className="standard-summary-row">
              <span>Remaining Wallet Balance:</span>
              <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>
                ₹{data?.remainingWalletAmount ?? data?.advancedGiven ?? 0}
              </span>
            </div>
          )}
    </div>
  );
};

export default ReviewBillPdf;